import { loyaltyTiers, type LoyaltyTier } from "@cliqsuite/db/schemas";
import { useRows } from "./db";

/** The tiers this store's owner set up, lowest first. */
export function useLoyaltyTiers(storeId: string): LoyaltyTier[] {
  const { data } = useRows("loyalty_configs", "SELECT * FROM loyalty_configs WHERE store_id = ?", [storeId]);
  return loyaltyTiers(data[0]?.tiers);
}

/** Points earned per 1,000 MMK for this store — 0 while the program is paused/unconfigured. Mirrors apps/pos's identical hook. */
export function useLoyaltyEarnRate(storeId: string): number {
  const { data } = useRows("loyalty_configs", "SELECT * FROM loyalty_configs WHERE store_id = ?", [storeId]);
  const config = data[0] ?? null;
  if (!config || !config.is_active) return 0;
  return Number(config.earn_rate) || 0;
}
